import Image, { type ImageProps } from "next/image";

export const Img = (props: ImageProps) => {
  const assetUrls = [
    "assetscms.foodango.",
    "cms.foodango.",
    "assetscmsqa1.foodango.",
  ];
  // In the case of images from assetscms.foodango.* (e.g., .pl, .cz) - Skip Next.js optimization
  const isAssetsCmsDomain = assetUrls.some(
    (url) => typeof props.src === "string" && props.src?.includes(url),
  );

  if (isAssetsCmsDomain) {
    return <Image {...props} unoptimized={true} />;
  }

  // In the case of images from static.caterings.pl - Apply Cloudflare image transformation
  const isStaticCateringsDomain =
    typeof props.src === "string" && props.src.includes("static.caterings.pl");
  if (isStaticCateringsDomain && typeof props.src === "string") {
    const imageUrl = new URL(props.src);
    const cfOptions = "format=auto,quality=auto,onerror=redirect";
    const transformedUrl = `${imageUrl.protocol}//${imageUrl.host}/cdn-cgi/image/${cfOptions}${imageUrl.pathname}`;

    return <Image {...props} src={transformedUrl} unoptimized={true} />;
  }

  // For all other images, use Next.js optimization
  return <Image {...props} unoptimized={false} />;
};
